/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Toggle_Fast_ForwardInputs */

const en_shortcut_keys_name_toggle_fast_forward = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle Fast Forward`)
};

const fr_shortcut_keys_name_toggle_fast_forward = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer avance rapide`)
};

const de_shortcut_keys_name_toggle_fast_forward = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnellvorlauf umschalten`)
};

const it_shortcut_keys_name_toggle_fast_forward = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva avanzamento rapido`)
};

const ru_shortcut_keys_name_toggle_fast_forward = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить перемотку вперед`)
};

const es_shortcut_keys_name_toggle_fast_forward = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar avance rápido`)
};

const zh_cn2_shortcut_keys_name_toggle_fast_forward = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换快进`)
};

const ja_shortcut_keys_name_toggle_fast_forward = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`早送りを切り替える`)
};

const hi_shortcut_keys_name_toggle_fast_forward = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ास्ट फ़ॉरवर्ड टॉगल करें`)
};

const pt_pt2_shortcut_keys_name_toggle_fast_forward = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Fast_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar Avanço Rápido`)
};

/**
* | output |
* | --- |
* | "Toggle Fast Forward" |
*
* @param {Shortcut_Keys_Name_Toggle_Fast_ForwardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_toggle_fast_forward = /** @type {((inputs?: Shortcut_Keys_Name_Toggle_Fast_ForwardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Toggle_Fast_ForwardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_toggle_fast_forward(inputs)
	if (locale === "de") return de_shortcut_keys_name_toggle_fast_forward(inputs)
	if (locale === "it") return it_shortcut_keys_name_toggle_fast_forward(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_toggle_fast_forward(inputs)
	if (locale === "es") return es_shortcut_keys_name_toggle_fast_forward(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_toggle_fast_forward(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_toggle_fast_forward(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_toggle_fast_forward(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_toggle_fast_forward(inputs)
	return en_shortcut_keys_name_toggle_fast_forward(inputs)
});